import { Flex, Text, Center } from '@chakra-ui/react'
import { Link } from '@chakra-ui/next-js'
import { Headphones } from 'components/icons'
import { INSTITUTION_SLUG } from 'constants/system'

export default function SupportButton() {
  return (
    <Link
      href={
        INSTITUTION_SLUG == 'agsus'
          ? 'https://wa.me/5521971364964?text=Ol%C3%A1%2C+preciso+de+ajuda+com+a+%2APlataforma+Impacto%2A'
          : 'https://wa.me/5512997733752?text=Ol%C3%A1%2C+preciso+de+ajuda+com+a+%2APlataforma+Impacto%2A'
      }
      target="_blank"
      _hover={{ textDecor: 'none' }}
    >
      <Flex w="300px" p={2} justify="space-between">
        <Flex flexDir="column" justify="center" gap={1}>
          <Text fontSize="sm" fontWeight="bold">
            Equipe de suporte
          </Text>
          <Text fontSize="xs">Responderemos em algumas horas</Text>
        </Flex>
        <Center w="80px">
          <Headphones variant="twoTone" boxSize={14} />
        </Center>
      </Flex>
    </Link>
  )
}
